import { Injectable } from '@angular/core';
import { CrudService } from 'app/shared/crud-service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Resolve
} from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class VendedorEmpresaService extends CrudService<any>{
    routeParams: any;

    constructor(protected http: HttpClient,
        ) {
        super(http, `${environment.apiUrl}/v1/EmpresaVendedor`);
    }


    saveAllEmpresaVendedor(lista: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${environment.apiUrl}/v1/EmpresaVendedor/SaveAll/`, lista).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }
  
}
